/** @format */

import { getDocument } from "pdfjs-dist/build/pdf";
// const { PDFDocument } = require("pdf-lib");
// const { PDFDocument, rgb } = pdfjsLib;
import { PDFDocument } from "pdf-lib";
// import { kycApi } from "../services/kycApi";

export async function createPdfFromCanvases(canvasArray) {
  const pdfDoc = await PDFDocument();

  canvasArray.forEach((canvas) => {
    const imageData = canvas.toDataURL("image/png");
    pdfDoc.addImage(imageData, "PNG", 0, 0, canvas.width, canvas.height);
    pdfDoc.addPage();
  });

  const pdfBytes = await pdfDoc.save();
  return pdfBytes;
}

export const convertToPDF = async (canvasList, resolution = 1) => {
  // Create a new PDF document
  const pdfDoc = await PDFDocument.create();

  // Iterate over each canvas and add it as a page to the PDF document
  for (let i = 0; i < canvasList.length; i++) {
    const canvas = canvasList[i];

    // Create a new canvas with higher resolution
    const scaledCanvas = document.createElement("canvas");
    scaledCanvas.width = canvas.width * resolution;
    scaledCanvas.height = canvas.height * resolution;
    const context = scaledCanvas.getContext("2d");
    context.scale(resolution, resolution);
    context.drawImage(canvas, 0, 0);

    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    // Get the data URL of the scaled canvas as an image (using PNG format for higher quality)
    const imageDataUrl = scaledCanvas.toDataURL("image/png");

    // Add the image as a new page to the PDF document
    const pngImage = await pdfDoc.embedPng(imageDataUrl);
    const page = pdfDoc.addPage();
    const { width, height } = page.getSize();
    page.drawImage(pngImage, {
      x: 0,
      y: 0,
      width: width,
      height: height,
    });
  }

  // Get the PDF document as a blob
  const pdfBytes = await pdfDoc.save();

  // Convert blob to URL
  const pdfUrl = URL.createObjectURL(
    new Blob([pdfBytes], { type: "application/pdf" })
  );

  // Open the PDF in a new tab
  window.open(pdfUrl, "_blank");
  return pdfUrl;
};

// export const convertToPDF = async (canvasList, resolution = 2) => {
//   // Create a new PDF document
//   const pdfDoc = await PDFDocument.create();

//   for (let i = 0; i < canvasList.length; i++) {
//     const canvas = canvasList[i];

//     // Create a new canvas with higher resolution
//     const scaledCanvas = document.createElement("canvas");
//     scaledCanvas.width = canvas.width * resolution;
//     scaledCanvas.height = canvas.height * resolution;
//     const context = scaledCanvas.getContext("2d");
//     context.scale(resolution, resolution);
//     context.drawImage(canvas, 0, 0);

//     context.imageSmoothingEnabled = true;
//     context.imageSmoothingQuality = "high";

//     // Convert the scaled canvas to a Blob
//     const blob = await new Promise((resolve) => scaledCanvas.toBlob(resolve, "image/png"));

//     if (!blob) {
//       console.error("Failed to convert canvas to Blob");
//       continue;
//     }

//     // Create an array buffer from the Blob
//     const arrayBuffer = await blob.arrayBuffer();

//     // Embed the PNG image from the array buffer
//     const pngImage = await pdfDoc.embedPng(arrayBuffer);
//     const page = pdfDoc.addPage();
//     const { width, height } = page.getSize();
//     page.drawImage(pngImage, {
//       x: 0,
//       y: 0,
//       width: width,
//       height: height,
//     });
//   }

//   return pdfDoc.save(); // Return the PDF document as a Uint8Array
// };

export const createCanvas = async (data, scale = 1) => {
  const blob = await new Blob([data], { type: "application/pdf" });
  // Create a data URL from the Blob
  const dataUrl = await URL.createObjectURL(blob);

  const pdf = await getDocument({ url: dataUrl }).promise;
  const canvasPages = [];

  const numPages = pdf.numPages;

  for (let i = 1; i <= numPages; i++) {
    const page = await pdf.getPage(i);
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    await page.render(renderContext).promise;

    canvasPages.push({
      canvas: canvas,
      id: `page-${i}`,
    });
  }
  return canvasPages;
};

// export const createCanvas = async (data, scale = 2) => {
//   const blob = new Blob([data], { type: "application/pdf" });

//   // Create a data URL from the Blob
//   const dataUrl = URL.createObjectURL(blob);

//   const pdf = await getDocument({ url: dataUrl }).promise;
//   const canvasPages = [];

//   const numPages = pdf.numPages;

//   for (let i = 1; i <= numPages; i++) {
//     const page = await pdf.getPage(i);

//     // Increase the scale to improve quality
//     const viewport = page.getViewport({ scale });

//     const canvas = document.createElement("canvas");
//     const context = canvas.getContext("2d");

//     // Set canvas dimensions based on the scaled viewport
//     canvas.width = viewport.width;
//     canvas.height = viewport.height;

//     // Improve quality by enabling image smoothing
//     context.imageSmoothingEnabled = true;
//     context.imageSmoothingQuality = "high";

//     const renderContext = {
//       canvasContext: context,
//       viewport: viewport,
//     };

//     await page.render(renderContext).promise;

//     // Add the canvas to the array
//     canvasPages.push({
//       canvas: canvas,
//       id: `page-${i}`,
//     });
//   }

//   // Revoke the data URL to free up memory
//   URL.revokeObjectURL(dataUrl);

//   return canvasPages;
// };
// export const createCanvasReplace = async (data, scale = 2) => {
//   // Create a Blob from the PDF data
//   const blob = new Blob([data], { type: "application/pdf" });
//   const dataUrl = URL.createObjectURL(blob);

//   // Load the PDF document using pdf.js
//   const pdf = await getDocument({ url: dataUrl }).promise;
//   const canvasPages = [];

//   const numPages = pdf.numPages;

//   // Define a fixed device pixel ratio
//   const devicePixelRatio = 2; // Adjust as needed to maintain consistency with `createMergePDFCanvas`

//   for (let i = 1; i <= numPages; i++) {
//     const page = await pdf.getPage(i);

//     // Use a scale factor that accounts for device pixel ratio to improve quality
//     const viewport = page.getViewport({ scale: scale * devicePixelRatio });

//     const canvas = document.createElement("canvas");
//     const context = canvas.getContext("2d");

//     // Set canvas dimensions considering scale and devicePixelRatio for high-resolution screens
//     canvas.width = viewport.width * devicePixelRatio;
//     canvas.height = viewport.height * devicePixelRatio;

//     // Set the style width and height to match the original viewport size (no scaling here)
//     canvas.style.width = `${viewport.width}px`;
//     canvas.style.height = `${viewport.height}px`;

//     // Apply scaling for high-resolution rendering
//     context.scale(devicePixelRatio, devicePixelRatio);

//     // Ensure high-quality image smoothing and rendering
//     context.imageSmoothingEnabled = true;
//     context.imageSmoothingQuality = "high";

//     const renderContext = {
//       canvasContext: context,
//       viewport: viewport,
//     };

//     // Render the page onto the canvas
//     await page.render(renderContext).promise;

//     // Store the canvas with the page identifier
//     canvasPages.push({
//       canvas: canvas,
//       id: `page-${i}`,
//     });
//   }

//   // Revoke the URL to release memory
//   URL.revokeObjectURL(dataUrl);

//   return canvasPages;
// };

export const createCanvasReplace = async (data, scale = 1) => {
  // Create a Blob from the PDF data
  const blob = new Blob([data], { type: "application/pdf" });
  const dataUrl = URL.createObjectURL(blob);

  // Load the PDF document using pdf.js
  const pdf = await getDocument({ url: dataUrl }).promise;
  const canvasPages = [];

  const numPages = pdf.numPages;

  // Define a fixed device pixel ratio
  const devicePixelRatio = 1; // Adjust as needed to maintain consistency with createMergePDFCanvas

  for (let i = 1; i <= numPages; i++) {
    const page = await pdf.getPage(i);

    // Use a scale factor that accounts for device pixel ratio to improve quality
    const viewport = page.getViewport({ scale: scale * devicePixelRatio });

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    // Set canvas dimensions considering scale and devicePixelRatio for high-resolution screens
    canvas.width = viewport.width * devicePixelRatio;
    canvas.height = viewport.height * devicePixelRatio;

    // Set the style width and height to match the original viewport size (no scaling here)
    canvas.style.width = `${viewport.width}px`;
    canvas.style.height = `${viewport.height}px`;

    // Apply scaling for high-resolution rendering
    context.scale(devicePixelRatio, devicePixelRatio);

    // Ensure high-quality image smoothing and rendering
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";

    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    // Render the page onto the canvas
    await page.render(renderContext).promise;

    // Store the canvas with the page identifier
    canvasPages.push({
      canvas: canvas,
      id: `page-${i}`,
    });
  }

  // Revoke the URL to release memory
  URL.revokeObjectURL(dataUrl);

  return canvasPages;
};

// export const createMergePDFCanvas = async (data, scale = 1) => {
//   const blob = new Blob([data], { type: "application/pdf" });
//   const dataUrl = URL.createObjectURL(blob);

//   const pdf = await getDocument({ url: dataUrl }).promise;
//   const canvasPages = [];

//   const numPages = pdf.numPages;
//   const devicePixelRatio = window.devicePixelRatio || 1;

//   for (let i = 1; i <= numPages; i++) {
//     const page = await pdf.getPage(i);
//     const viewport = page.getViewport({ scale });
//     const canvas = document.createElement("canvas");
//     const context = canvas.getContext("2d");
//     canvas.width = viewport.width * devicePixelRatio;
//     canvas.height = viewport.height * devicePixelRatio;
//     canvas.style.width = `${viewport.width}px`;
//     canvas.style.height = `${viewport.height}px`;

//     context.scale(devicePixelRatio, devicePixelRatio);

//     const renderContext = {
//       canvasContext: context,
//       viewport: viewport,
//     };

//     await page.render(renderContext).promise;

//     canvasPages.push({
//       canvas: canvas,
//       id: `page-${i}`,
//     });
//   }
//   return canvasPages;
// };

// export const createMergePDFCanvas = async (data, scale = 1) => {
//   // Create a Blob from the PDF data
//   const blob = new Blob([data], { type: "application/pdf" });
//   const dataUrl = URL.createObjectURL(blob);

//   // Load the PDF document using pdf.js
//   const pdf = await getDocument({ url: dataUrl }).promise;
//   const canvasPages = [];

//   // Get the device pixel ratio to scale the rendering for high-resolution displays
//   const devicePixelRatio = 1.05;
//   // const devicePixelRatio = window.devicePixelRatio || 1;

//   const numPages = pdf.numPages;

//   for (let i = 1; i <= numPages; i++) {
//     const page = await pdf.getPage(i);

//     // Use a scale factor that accounts for device pixel ratio to improve quality
//     const viewport = page.getViewport({ scale: scale * devicePixelRatio });

//     const canvas = document.createElement("canvas");
//     const context = canvas.getContext("2d");

//     // Set canvas dimensions considering scale and devicePixelRatio for high-resolution screens
//     canvas.width = viewport.width * devicePixelRatio;
//     canvas.height = viewport.height * devicePixelRatio;

//     // Set the style width and height to match the original viewport size (no scaling here)
//     canvas.style.width = `${viewport.width}px`;
//     canvas.style.height = `${viewport.height}px`;

//     // Apply scaling for high-resolution rendering
//     context.scale(devicePixelRatio, devicePixelRatio);

//     // Ensure high-quality image smoothing and rendering
//     context.imageSmoothingEnabled = true;
//     context.imageSmoothingQuality = "high";

//     const renderContext = {
//       canvasContext: context,
//       viewport: viewport,
//     };

//     // Render the page onto the canvas
//     await page.render(renderContext).promise;

//     // Store the canvas with the page identifier
//     canvasPages.push({
//       canvas: canvas,
//       id: `page-${i}`,
//     });
//   }

//   // Revoke the URL to release memory
//   URL.revokeObjectURL(dataUrl);

//   return canvasPages;
// };

export const createMergePDFCanvas = async (data, scale = 1) => {
  // Create a Blob from the PDF data
  const blob = new Blob([data], { type: "application/pdf" });
  const dataUrl = URL.createObjectURL(blob);

  // Load the PDF document using pdf.js
  const pdf = await getDocument({ url: dataUrl }).promise;
  const canvasPages = [];

  // Get the device pixel ratio to scale the rendering for high-resolution displays
  const devicePixelRatio = 1;
  // const devicePixelRatio = window.devicePixelRatio || 1;

  const numPages = pdf.numPages;

  let totalSizeInBytes = 0; // Initialize a variable to store the total size in bytes

  for (let i = 1; i <= numPages; i++) {
    const page = await pdf.getPage(i);

    // Use a scale factor that accounts for device pixel ratio to improve quality
    const viewport = page.getViewport({ scale: scale * devicePixelRatio });

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    // Set canvas dimensions considering scale and devicePixelRatio for high-resolution screens
    canvas.width = viewport.width * devicePixelRatio;
    canvas.height = viewport.height * devicePixelRatio;

    // Set the style width and height to match the original viewport size (no scaling here)
    canvas.style.width = `${viewport.width}px`;
    canvas.style.height = `${viewport.height}px`;

    // Apply scaling for high-resolution rendering
    context.scale(devicePixelRatio, devicePixelRatio);

    // Ensure high-quality image smoothing and rendering
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";

    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    // Render the page onto the canvas
    await page.render(renderContext).promise;

    // Convert the canvas to a data URL (PNG format)
    const jpegQuality = 0.7;
    const dataUrl = canvas.toDataURL("image/jpeg", jpegQuality);
    // const dataUrl = canvas.toDataURL("image/png");

    // Calculate the size of the data URL in bytes and add it to the total size
    const dataUrlSizeInBytes = Math.ceil((dataUrl.length * 3) / 4);
    totalSizeInBytes += dataUrlSizeInBytes;

    // Store the canvas with the page identifier
    canvasPages.push({
      canvas: canvas,
      id: `page-${i}`,
    });
  }

  // Revoke the URL to release memory
  URL.revokeObjectURL(dataUrl);

  // Convert the total size to MB
  const totalSizeInMB = totalSizeInBytes / (1024 * 1024);
  console.log(`Total size of all canvas pages: ${totalSizeInMB.toFixed(2)} MB`);

  return canvasPages;
};

export const getMousePos = (clientX, clientY, canvasRef) => {
  const canvasRect = canvasRef.current.getBoundingClientRect();
  const axisY = clientY - canvasRect.top;
  const mouseX = clientX - canvasRect.left;
  return { x: mouseX, y: axisY };
};

export const scrollToId = (id, pdfPages, containerRef) => {
  if (!id || !pdfPages) return;
  console.log("scrolltoid data: ", id, pdfPages, containerRef);
  const pageIndex =
    pdfPages.length > 0 && pdfPages.findIndex((page) => page.id === id);
  if (pageIndex !== -1 && containerRef?.current) {
    const pageElement = containerRef.current.children[pageIndex];
    if (pageElement) {
      pageElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
};

export const scrollToId2 = (id, pdfPages, containerRef) => {
  if (!id || !pdfPages || !containerRef?.current) return;
  // console.log('scrolltoid2 data: ',id, pdfPages, containerRef)
  // Find the page with the matching id

  let splitId = id?.split("-")?.[1];
  if (splitId) {
    if (Number(splitId) > pdfPages?.length - 2) {
      console.log("scrolltoid2 data: splitid is", splitId);
      if (splitId == pdfPages?.length - 1) {
        // console.log("scrolltoid2 data: splitid is pdf pages length and splitid", pdfPages?.length, splitId)
        let pageIndex = pdfPages?.length - 1;
        let pageElement = containerRef.current.children[pageIndex - 1];
        if (pageElement) {
          pageElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          return;
        }
      } else if (splitId == pdfPages?.length) {
        // console.log("scrolltoid2 data: splitid is pdf pages length and splitid-1", pdfPages?.length, splitId)
        let pageIndex = pdfPages?.length - 1;
        let pageElement = containerRef.current.children[pageIndex];
        if (pageElement) {
          pageElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          return;
        }
      }
    }
  }
  const pageIndex = pdfPages.findIndex((page) => page.id === id);
  // console.log("scrolltoid2 data: index: ", pageIndex)
  if (pageIndex !== -1) {
    // Find the page element directly using the id instead of relying on index
    let pageElement;
    if (pageIndex === 2) {
      pageElement = containerRef.current.children[0];
    } else if (pageIndex === 0) {
      // console.log('scrolltoid2 data: yes inside 0 index condidtion')
      pageElement = containerRef.current.children[0];
    } else {
      pageElement = containerRef.current.children[pageIndex - 2];
    }

    if (pageElement) {
      pageElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      console.warn("Page element not found for id:", id);
    }
  } else {
    console.warn("Page with specified id not found:", id);
  }
};

export function transformData(inputData, scale = 1.5) {
  let id = Date.now();
  console.log('inputData', inputData)
  const transformedData = Object.entries(inputData).flatMap(
    ([pageNumber, pageData]) =>
      Object.entries(pageData).flatMap(([key, values]) =>
        values.map((item, index) => ({
          id: id++,
          pageNumber: parseInt(pageNumber),
          ...item,
          fontSize: item["font-size"],
          value: key,
          width: item["width"] * scale,
          height: item["height"] * scale,
          // width: Math.floor(item["width"] * scale),
          // height: Math.floor(item["height"] * scale),
          "y-coordinate":
            item.data_type === "text"
              ? parseInt(item["y-coordinate"]) - 10
              : item["y-coordinate"],
        }))
      )
  );
  return transformedData;
}

// export function transformDataInObj(data, scale = 1.5) {
//   const transformedData = data.reduce((acc, item) => {
//     const { pageNumber, value, fontSize, ...rest } = item;
//     console.log(data);
//     // let height = Math.floor(rest?.height / scale);
//     // let width = Math.floor(rest?.width / scale);
//     let height = rest?.height / scale;
//     let width = rest?.width / scale;
//     let y_coordinate =
//       rest.data_type === "text"
//         ? rest?.["y-coordinate"] + 10
//         : rest?.["y-coordinate"];
//     let restData = {
//       ...rest,
//       height,
//       width,
//       "y-coordinate": y_coordinate,
//       "font-size": fontSize,
//     };
//     if (!acc[pageNumber]) {
//       acc[pageNumber] = {};
//     }
//     if (!acc[pageNumber][value]) {
//       acc[pageNumber][value] = [];
//     }
//     acc[pageNumber][value].push(restData);
//     return acc;
//   }, {});

//   return transformedData;
// }

export function transformDataInObj(data, scale = 1.5) {
  const transformedData = data.reduce((acc, item) => {
    const {
      pageNumber,
      value,
      fontSize,
      addTextBox,
      eraserBox,
      addImageBox,
      fieldValue,
      imageUrl,
      shape,
      ...rest
    } = item;

    let height = rest?.height / scale;
    let width = rest?.width / scale;

    let y_coordinate;
    if (rest.data_type === "text") {
      y_coordinate = rest?.["y-coordinate"] + 10;
    } else {
      y_coordinate = rest?.["y-coordinate"];
    }

    // let y_coordinate =
    //   rest.data_type === "text"
    //     ? rest?.["y-coordinate"] + 10
    //     : rest?.["y-coordinate"];

    let restData;
    if (addTextBox) {
      restData = {
        ...rest,
        addTextBox: true,
        fieldValue: fieldValue || value,
        height,
        width,
        "y-coordinate": y_coordinate,
        "font-size": fontSize,
      };
    } else if (eraserBox) {
      restData = {
        ...rest,
        addTextBox: false,
        eraserBox: true,
        fieldValue: "",
        value: "eraseVal",
        height,
        width,
        "y-coordinate": y_coordinate,
        "font-size": fontSize,
      };
    } else if (addImageBox) {
      restData = {
        ...rest,
        data_type: "image_type",
        addTextBox: false,
        eraserBox: false,
        addImageBox: true,
        fieldValue: "",
        value: "imageVal",
        imageUrl: imageUrl || "",
        height,
        width,
        "y-coordinate": y_coordinate,
        "font-size": fontSize,
      };
    } else if (shape) {
      restData = {
        ...rest,
        addTextBox: false,
        eraseBox: false,
        addImageBox: false,
        height,
        width,
        shape: shape,
        "y-coordinate": y_coordinate,
      };
    } else {
      restData = {
        ...rest,
        height,
        width,
        "y-coordinate": y_coordinate,
        "font-size": fontSize,
      };
    }

    // If addTextBox is false or not present, assign to textField
    const keyName = addTextBox
      ? "textField"
      : eraserBox
      ? "eraserField"
      : addImageBox
      ? "imageField"
      : shape
      ? "shapeField"
      : value;

    if (!acc[pageNumber]) {
      acc[pageNumber] = {};
    }
    if (!acc[pageNumber][keyName]) {
      acc[pageNumber][keyName] = [];
    }
    acc[pageNumber][keyName].push(restData);

    return acc;
  }, {});

  return transformedData;
}

export function transformedOtherAction(deletedData, addedData) {
  let result = {};
  deletedData.forEach((element) => {
    result[element] = { delete: true };
  });
  addedData.forEach((element, i) => {
    result[element] = { insert: true };
  });
  return result;
}

// Transform data for preview pdf ==>
export const transformPreviewPdfData = (coordinates) => {
  console.log(coordinates);
  let data = {};
  coordinates.forEach((element) => {
    if (element.data_type === "text") {
      data[element.value] = "Dummy Text";
    } else if (element.width <= 40 && element.data_type === "image") {
      data[element.value] =
        "https://www.citypng.com/public/uploads/preview/hd-green-check-true-tick-mark-icon-sign-png-701751695051734c81jqywfaq.png";
    } else if (
      element.data_type === "image" ||
      element.data_type === "multi_signers" ||
      element.data_type === "watermark_image" ||
      element.data_type === "digital_stamp"
      // element.data_type === "Stamppaper"
    ) {
      data[element.value] =
        "https://media.istockphoto.com/id/1373102516/photo/abstract-minimal-white-and-grey-background-3d-rendering-pattern-texture.jpg?s=2048x2048&w=is&k=20&c=UdvptFCXiUB5vqaiSmjCzUn8OWwLI_xH4hiHF-k9PmQ=";
    }
  });
  console.log(data);
  return data;
};

// Delete coordinates data from deleted page ==>
export const deleteCoordinates = (pageNumber, data) => {
  let filterData = data.filter((item) => pageNumber !== item.pageNumber);
  return filterData;
};

// return added pdf Pages ===>
export const getAddedPdf = (data) => {
  let output = {};
  for (let key in data) {
    let startAt = data[key]["start_at"];
    if (!output[startAt]) {
      output[startAt] = [key];
    } else {
      output[startAt].push(key);
    }
  }
  return output;
};

// modify pdf data when save coordinate

export const modifyAddedPdfData = (input) => {
  let output = {};
  for (let key in input) {
    let startAt = parseInt(key); // Parse the key to integer
    let values = input[key]; // Get the array of values for the current key
    for (let value of values) {
      output[value] = {
        start_at: startAt,
        from_page: "",
        to_page: "",
        document: {
          url: "",
          media_id: "",
        },
      };
    }
  }
  return output;
};

// modify pdf data when save coordinate sequence

export const modifyAddedPdfDataSequence = (input) => {
  let output = [];

  try {
    // Validate if the input is an object
    if (typeof input !== "object" || input === null) {
      throw new Error("Invalid input: Input should be a non-null object.");
    }

    // Iterate through the keys without sorting
    for (let key in input) {
      let startAt = parseInt(key); // Parse the key to integer (if possible)

      if (isNaN(startAt)) {
        throw new Error(`Invalid key: ${key} is not a valid number.`);
      }

      let values = input[key]; // Get the array of values for the current key

      // Validate if the values are an array
      if (!Array.isArray(values)) {
        throw new Error(`Invalid value: Expected an array for key ${key}.`);
      }

      for (let value of values) {
        // Validate if the value is a string (the name)
        if (typeof value !== "string") {
          throw new Error(
            `Invalid value in key ${key}: Each value should be a string.`
          );
        }

        // Create the desired object structure
        let newObj = {
          [value]: {
            start_at: startAt,
            from_page: "",
            to_page: "",
            document: {
              url: "",
              media_id: "",
            },
          },
        };

        // Push the new object into the output array
        output.push(newObj);
      }
    }

    return output;
  } catch (error) {
    console.error(error.message);
    return []; // Return an empty array in case of an error
  }
};

// transform select Data ============>

export const transformSelectData = (data) => {
  let transformData = Object.keys(data).map((item) => ({
    value: {
      variableName: item,
      data_type: data[item]?.type
        ? data[item]?.type
        : data[item] === "file"
        ? "image"
        : data[item] === "number" ||
          data[item] === "email" ||
          data[item] === "date"
        ? "text"
        : data[item],
      values: data[item]?.values ? data[item]?.values : [],
    },
    label: item,
  }));
  console.log("transformData", transformData);
  return transformData;
};

export let ex = [
  {
    value: {
      data_type: "multi_signers",
      variableName: "multi_signers.signer_1",
      values: [],
    },
    label: "multi_signers",
  },
  {
    value: {
      data_type: "multi_signers",
      variableName: "multi_signers.signer_2",
      values: [],
    },
    label: "multi_signers2",
  },
  {
    value: {
      data_type: "multi_signers",
      variableName: "multi_signers.signer_3",
      values: [],
    },
    label: "multi_signers",
  },
];

export const filterDigitalStampAndMultiSignerData = (data, pageHeight) => {
  let type = sessionStorage.getItem("type");
  if (type !== "kyc") return;
  console.log(data);
  const filteredData = {};
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const obj = data[key];
      for (const innerKey in obj) {
        if (obj.hasOwnProperty(innerKey)) {
          const innerObj = obj[innerKey];
          for (const item of innerObj) {
            if (item.data_type === "digital_stamp") {
              // Remove "digital_stamp." prefix from the key
              const trimmedKey = innerKey.replace("digital_stamp.", "");
              if (!filteredData[key]) {
                filteredData[key] = {};
              }
              // Add the item to the filteredData object with the trimmed key
              if (!filteredData[key][trimmedKey]) {
                filteredData[key][trimmedKey] = [];
              }
              filteredData[key][trimmedKey].push(item);
            } else if (item.data_type === "multi_signers") {
              // Remove "digital_stamp." prefix from the key
              const trimmedKey = innerKey.replace("multi_signers.", "");
              if (!filteredData[key]) {
                filteredData[key] = {};
              }
              // Add the item to the filteredData object with the trimmed key
              if (!filteredData[key][trimmedKey]) {
                filteredData[key][trimmedKey] = [];
              }
              console.log("item", item);
              filteredData[key][trimmedKey].push(item);
            }
          }
        }
      }
    }
  }

  return filteredData;
};

export const dynamicEsignData = (data, pageHeight) => {
  console.log("data----->", data);
  console.log("pageheight", pageHeight);
  let type = sessionStorage.getItem("type");
  if (type !== "kyc") return;
  let filteredData = JSON.parse(JSON.stringify(data));
  for (let key in filteredData) {
    if (filteredData.hasOwnProperty(key)) {
      let entry = filteredData[key];
      for (let signerKey in entry) {
        console.log("signerss1", entry[signerKey]);
        if (
          signerKey !== "signer_1" &&
          entry[signerKey].some(
            (signer) => signer.data_type === "multi_signers"
          )
        ) {
          entry[signerKey].forEach((signer) => {
            console.log("signer------", signer);
            let y = pageHeight[key - 1];
            signer["y-coordinate"] =
              y - signer["y-coordinate"] - signer["height"];
          });
        }
      }
    }
  }
  return filteredData;
};

let kycDefaultData = [
  {
    value: {
      data_type: "digital_stamp",
      variableName: "digital_stamp",
      values: [],
    },
    label: "Dynamic Stamp",
  },
  // {
  //   value: {
  //     data_type: "Stamppaper",
  //     variableName: "Stamppaper",
  //     values: [],
  //   },
  //   label: "Stamp Paper",
  // },
  {
    value: {
      data_type: "watermark_image",
      variableName: "watermark_image",
      values: [],
    },
    label: "Add Stamp",
  },
  {
    value: {
      data_type: "multi_signers",
      variableName: "multi_signers",
      values: [],
    },
    label: "Multi Signer Stamp",
  },
  {
    value: {
      data_type: "image",
      variableName: "permanent_checkbox",
      values: [],
    },
    label: "Permanent Checkbox",
  },
];
// export async function kycDefaultSelectData(workflow_key) {
//   const fetchValuesFromAPI = async (dataType) => {
//     if (dataType === "digital_stamp") {
//       return kycApi.fetchDynamicEsignCheckBox(workflow_key).then((res) => {
//         if (res?.success) {
//           return res.data;
//         } else {
//           return [""];
//         }
//       });
//     } else if (dataType === "multi_signers") {
//       return kycApi.fetchMultiSigner(workflow_key).then((response) => {
//         if (response?.success) {
//           return Array.from({
//             length: response?.signer_counts,
//           }).map((item, index) => {
//             return `signer_${index + 1}`;
//           });
//         }
//         throw new Error("Failed to fetch multi signers data");
//       });
//     }
//     throw new Error("Invalid data type");
//   };

//   // Find the item with data_type: "digital_stamp"
//   const digitalStampItem = kycDefaultData.find(
//     (item) => item.value.data_type === "digital_stamp"
//   );
//   // Find the item with data_type: "multi_signers"
//   const multiSignersItem = kycDefaultData.find(
//     (item) => item.value.data_type === "multi_signers"
//   );

//   const promises = [];

//   if (digitalStampItem) {
//     // Update values for digital_stamp item
//     const promise = fetchValuesFromAPI(digitalStampItem.value.data_type).then(
//       (values) => {
//         console.log("values", values);
//         digitalStampItem.value.values = values;
//       }
//     );
//     promises.push(promise);
//   }

//   if (multiSignersItem) {
//     const promise = fetchValuesFromAPI(multiSignersItem.value.data_type).then(
//       (values) => (multiSignersItem.value.values = values)
//     );
//     promises.push(promise);
//   }

//   await Promise.all(promises);
//   return kycDefaultData;
// }

// rekyc pdf type

export const rekycPdfType = [
  { label: "Equity", value: "EQUITY" },
  { label: "Kra", value: "KRA" },
  { label: "Equity Kra", value: "EQUITY_KRA" },
  { label: "Others", value: "OTHERS" },
];

export const handleUndo = ({
  modifiedCoordinates,
  modifiedCoordinateUndoFunc,
  pdfCoordinates,
  deleteCoordinate,
  coordinates,
  dispatch,
}) => {
  if (modifiedCoordinates?.length > 0) {
    let allCoords = modifiedCoordinates;
    let poppedItem = [...allCoords].pop();
    if (poppedItem) {
      if (poppedItem?.action === "removed") {
        // let actualItem = coordinates?.filter((item) => item.id === poppedItem?.id);
        // if(!actualItem?.length>0){
        //   actualItem = modifiedCoordinates?.filter((item) => item.id === poppedItem?.id);
        // }
        // if(actualItem?.length>0){
        //   dispatch(pdfCoordinates({action:"removed",...actualItem[0]}));
        //   dispatch(modifiedCoordinateUndoFunc({action:"removed",...actualItem[0]}));
        // }else{
        dispatch(modifiedCoordinateUndoFunc(poppedItem));
        console.log("pdfCoordinates",poppedItem)
        dispatch(pdfCoordinates(poppedItem));
        // }
      } else if (poppedItem?.action === "added") {
        let actualItem = coordinates?.filter(
          (item) => item.id === poppedItem?.id
        );
        if (actualItem?.length > 0) {
          dispatch(
            modifiedCoordinateUndoFunc({ action: "added", ...actualItem[0] })
          );
          dispatch(deleteCoordinate(poppedItem.id));
        }
      }
    }
  }
};
